// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9e10cec4","820":"81880276"}[chunkId] + ".chunk.js";
};